import React from 'react';
import ReactDOM from 'react-dom/client';
import './setup/monacoSetup';
import './i18n';
import App from './App';
import { installLangGraphProxyAuth } from './api/langgraphProxyAuth';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

installLangGraphProxyAuth();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
